import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '40%']);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  return <section ref={ref} className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-243">
      <motion.div style={{
      y
    }} className="absolute inset-0 w-full h-[120%] -top-[10%]" data-id="element-244">
        <div className="absolute inset-0 bg-[#1a1a2e]/40 z-10 mix-blend-multiply" data-id="element-245" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a2e]/50 via-transparent to-white z-10" data-id="element-246" />
        <img src="https://cdn.rawproductionsgmbh.de/shootingtrip/portugalmai2026/portugalmai2026-15.jpg" alt="Algarve coastal view" className="w-full h-full object-cover animate-ken-burns" data-id="element-247" />
      </motion.div>

      <motion.div style={{
      opacity
    }} className="relative z-20 max-w-5xl mx-auto px-6 text-center mt-20" data-id="element-248">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-249">
          <span className="block text-xs md:text-sm font-body tracking-[0.3em] text-white/90 uppercase mb-6" data-id="element-250">
            Exklusive Creative Shooting Trips
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-5xl md:text-7xl lg:text-8xl font-heading font-medium text-white mb-8 leading-tight drop-shadow-lg" data-id="element-251">
          Algarve <span className="italic text-white/80 font-light" data-id="element-252">—</span>{' '}
          <br className="md:hidden" data-id="element-253" />
          <span className="italic font-light" data-id="element-254">April 2026</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-12 font-light leading-relaxed drop-shadow-md" data-id="element-255">
          Fünf Tage kreative Fotografie an der atemberaubenden Küste Portugals.
          Für Models & Fotografen, die außergewöhnlichen Content erschaffen
          wollen.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-256">
          <a href="#bewerbung" className="w-full sm:w-auto px-8 py-4 bg-brand-accent/85 text-white font-medium text-sm tracking-wide rounded-sm hover:bg-brand-accent transition-all duration-300" data-id="element-257">
            Als Model bewerben
          </a>
          <a href="#bewerbung" className="w-full sm:w-auto px-8 py-4 border border-white/70 text-white font-medium text-sm tracking-wide rounded-sm hover:bg-white/10 transition-all duration-300 backdrop-blur-sm" data-id="element-258">
            Infos anfragen
          </a>
        </motion.div>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center" data-id="element-259">
        <span className="text-[10px] tracking-[0.2em] text-white/60 uppercase mb-3" data-id="element-260">
          Scroll
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-261">
          <ChevronDownIcon className="text-white/80 w-5 h-5" data-id="element-262" />
        </motion.div>
      </motion.div>
    </section>;
}